import { Box } from '@mui/material';
import type { ReactNode } from 'react';

export function LogoBox({ children }: Readonly<{ children: ReactNode }>): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60px',
        width: '70px',
        borderRadius: '12px',
        backgroundColor: theme => theme.palette.background.antiflashWhite,
      }}
    >
      {children}
    </Box>
  );
}
